;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionScale', {
    controller: Controller,
    templateUrl: 'survey-question-scale.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.visibleChoices = ctrl.question.getVisibleChoices()

      // scale supports one independent choice shown outside the slider
      var independent = _.remove(ctrl.visibleChoices, function(choice) {
        return choice.data.isIndependent
      })
      ctrl.independent = independent[0]
    }
  }
})()
